import React from 'react';
import { Collapse, Nav, Navbar, NavItem, NavLink, NavbarToggler, TabContent, TabPane } from 'reactstrap';
import { Typography } from 'osu-react-components';
import classnames from 'classnames';
import Awarded from '../containers/Awarded';
import NominationsTab from '../containers/NominationsTab';

export default class ScoringTabs extends React.Component {
    constructor(props) {
        super(props);
        this.toggle = this.toggle.bind(this);
        this.state = {
            activeTab: props.tabIndex || 0,
            isNavbarOpen: false
        };
    }

    toggle(tab) {
        if (this.state.activeTab !== tab) {
            this.setState({
                activeTab: tab
            });
        }
    }

    renderNavLink = (values) => {
        const { title, tabId } = values
        const active = this.state.activeTab === tabId
        return <NavItem key={tabId}>
            <NavLink aria-label={`Open tab for ${title}`} className={classnames({ active })}
                onClick={() => { this.toggle(tabId); }}>
                <Typography color={active ? 'black' : 'gray'} variant={'body2'}>{title}</Typography>
            </NavLink>
        </NavItem >
    };

    scoringTabData = (tabIndex) => {
        const filterProps = {
            handleFilter: this.props.handleFilter,
            clearAllFilters: this.props.clearAllFilters
        };

        return [
            {
                title: 'Nominations',
                type: 'both',
                tabIndex,
                component: (tabIndex) => <NominationsTab parentContainer={this.props.parentContainer} tabIndex={tabIndex} {...filterProps} isAdmin={this.props.isAdmin} user={this.props.user} key={'all-nominees-tab'} />
            },
            {
                title: 'Awarded',
                type: 'both',
                tabIndex,
                component: (tabIndex) => <Awarded parentContainer={this.props.parentContainer} tabIndex={tabIndex} {...filterProps} isAdmin={this.props.isAdmin} user={this.props.user} key={'all-nominees-tab'} />
            },
        ]
    };

    render() {
        const { isAdmin, isReviewer } = this.props;
        const scoringTabData = this.scoringTabData();
        const expandNavbar = true;
        const renderTabViews = (tabData) => <div>
            <Navbar light expand={expandNavbar}>
                <NavbarToggler onClick={() => this.setState({ isNavbarOpen: !this.state.isNavbarOpen })} />
                <Collapse isOpen={this.state.isNavbarOpen} navbar>
                    <Nav navbar tabs={expandNavbar} style={{ width: "100%" }}>
                        {tabData.map(tab => this.renderNavLink(tab))}
                    </Nav>
                </Collapse>
            </Navbar>
            <TabContent className="mt-2" activeTab={this.state.activeTab}>
                {tabData.map((tab, index) => <TabPane key={index} tabId={tab.tabId}>
                    {tab.component(tab.tabId)}
                    </TabPane>)}
            </TabContent>
        </div>;

        if (isAdmin && isReviewer) {
            return renderTabViews(scoringTabData.map((item, index) => ({ ...item, tabId: index })))
        } else if (isAdmin) {
            const adminTabs = scoringTabData
                .filter(data => data.type === 'admin' || data.type === 'both')
                .map((item, index) => ({ ...item, tabId: index }));

            return renderTabViews(adminTabs)
        } else  {
            const reviewerTabs = scoringTabData
                .filter(data => data.type === 'reviewer' || data.type === 'both')
                .map((item, index) => ({ ...item, tabId: index }))

            return renderTabViews(reviewerTabs)
        } 

    }
}
